import './index.scss';

import React from 'react';

import { ReactComponent as GasFloIcon } from '../../assets/Images/print_gasflow.svg';
import { numberWithCommas } from '../../utils';

const ApprovedRetailer = ({ printData }) => {
  return (
    <div className="print_container">
      <h3 className="text-center mb-3">Power Gas Plant</h3>
      <div>
        <div className="d-flex justify-content-center">
          <span className="fw-bold fs-5">Receipt</span>
          <span className="print_container_badge ms-2 pt-1">{printData.customer_type}</span>
        </div>
        <span className="text-center d-block">
          {new Date(printData.receipt_date).toDateString()} |{' '}
          {new Date(printData.receipt_date).toLocaleTimeString()}
        </span>
      </div>
      <hr className="w-100" />
      <p className="text-secondary text-center">Customer Name</p>
      <p className="fw-bold text-center fs-6">{printData.customer_name}</p>
      <hr />
      <h5 className="text-secondary text-center">Filled Cylinders</h5>
      <div>
        {printData.filled_cylinders.map((cylinder) => (
          <div key={cylinder.cin} className="print_container_cylinders">
            <div className="d-flex justify-content-between">
              <span className="fw-bold">{cylinder.cin}</span>
              <span className="fw-bold">{cylinder.gas_quantity} Kg</span>
            </div>
          </div>
        ))}
      </div>
      <div>
        <div className="d-flex justify-content-between">
          <div>
            <p className="text-secondary">Total Gas Quantiy</p>
            <p className="fw-bold">{printData.total_gas} Kg</p>
          </div>
          <div>
            <p className="text-secondary">Price/Kg</p>
            <p className="fw-bold">
              {printData.currency} {printData.gas_price}
            </p>
          </div>
        </div>
      </div>
      <hr />
      <h5 className="text-secondary text-center">Amount</h5>
      <p className="text-center fw-bold fs-5">
        {printData.currency} {numberWithCommas(printData.amount, 2)}
      </p>
      <hr />
      <div>
        <p className="text-secondary">Amount Paid</p>
        {printData.amount_paid.map((payment, index) => (
          <div key={index} className="my-2">
            <div className="d-flex justify-content-between">
              <span className="fw-bold">
                {printData.currency} {numberWithCommas(payment.amount, 2)}
              </span>
              <span className="fw-bold print_container_method_badge">{payment.method}</span>
            </div>
          </div>
        ))}
      </div>
      <hr />
      <p className="text-secondary text-center">Total Amount Paid</p>
      <p className="fw-bold text-center">
        {printData.currency} {printData.total_amount_paid}
      </p>
      <hr />
      {printData.debt_repayment.length > 0 && (
        <>
          <p className="text-secondary text-center">Debt Repayment</p>
          {printData.debt_repayment.map((payment, index) => (
            <div key={index} className="my-2">
              <div className="d-flex justify-content-center">
                <span className="fw-bold">
                  {printData.currency} {numberWithCommas(payment.amount, 2)}
                </span>
              </div>
            </div>
          ))}
          <hr />
        </>
      )}
      <p className="text-secondary text-center">Powered By</p>
      <div className="d-flex justify-content-center">
        <GasFloIcon />
      </div>
    </div>
  );
};

export default ApprovedRetailer;
